import styled from "styled-components";
import {StepOperator} from "@/types/assistants.ts";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 13px;
`;

export const OperatorBadge = styled.div<{ operator: StepOperator }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  width: fit-content;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  border: 1px solid ${props => {
    switch (props.operator) {
        case 'PRINT': return 'none';
        case 'INPUT': return 'none';
        case 'SELECT': return 'none';
        case 'PICTURE': return 'none';
        case props.operator.startsWith('PROMPT') ? props.operator : '':
            return 'rgb(194, 194, 194)';
        case 'NOTIFY': return 'rgb(194, 194, 194)';
        case 'REQUEST': return 'rgb(194, 194, 194)';
        case 'DATA': return 'rgb(194, 194, 194)';
        case 'CODE': return 'rgb(194, 194, 194)';
        default: return '#999999';
    }
}};
  background: ${props => {
    switch (props.operator) {
        case 'PRINT': return 'rgb(77, 105, 156)';
        case props.operator.startsWith('PROMPT') ? props.operator : '':
            return '#fff';
        case 'DATA': return '#fff';
        case 'SCRIPT': return '#fff';
        case 'GOTO_STEP': return '#fff';
        case 'CODE': return '#fff';
        case 'NOTIFY': return '#fff';
        case 'LOG': return '#fff';
        case 'TRANSCRIBE': return '#fff';
        case 'REQUEST': return '#fff'
        case 'INPUT': return 'rgb(80, 130, 41)';
        case 'SELECT': return 'rgb(203, 156, 37)';
        case 'PICTURE': return 'rgb(214, 79, 79)';
        case 'SPEECH': return '#894FD6';
        default: return '#999999';
    }
}};
  color: ${props => {
    switch (props.operator) {
        case 'PROMPT':
        case props.operator.startsWith('PROMPT') ? props.operator : '':
            return 'black';
        case 'NOTIFY': return 'black';
        case 'DATA': return 'black';
        case 'CODE': return 'black';
        case 'TRANSCRIBE': return 'black';
        case 'LOG': return 'black';
        case 'SCRIPT': return 'black';
        case 'GOTO_STEP': return 'black';
        case 'REQUEST': return 'black';
        default: return 'white';
    }
}};
`;

export const BreadcrumbNav = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
  margin-bottom: 24px;

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

